export const dslVersion = '1.0.0'; // Semantic DSL version
